import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  PageStandardSettings,
  PageSettingsPanel,
} from 'apps/studio/components/settings/page/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/page/Base/design'
import { settingInputs } from 'apps/studio/components/settings/inputs'
import { updateSheet } from 'apps/formsCreationKit/store/actions/sharedActions'
import { activeSheetSelector } from 'apps/formsCreationKit/store/selectors/entities'
import { activeStyledPageSelector } from 'apps/studio/store/selectors/pdf'
import { slugify } from 'apps/builder/lib/utils'
import { pagesActions } from 'apps/studio/store/reducers/entities/pages'
const { updatePageStyles } = pagesActions

const updateAction = ({ updateType, page, sheet, data }) => {
  switch (updateType) {
    case 'sheet':
      return updateSheet({
        id: sheet.id,
        section_id: sheet.section_id, 
        multi_section: sheet.multi_section,
        ...data,
      })
    case 'pageStyles':
    default:
      return updatePageStyles({ id: page.id, ...data })
  }
}

const getData = ({ updateType, page, sheet }) => {
  switch (updateType) {
    case 'sheet':
      return sheet
    case 'pageStyles':
    default:
      return page.styles
  }
}

const PageSetting = ({ page, sheet, config }) => {
  const { label, labelLarge, settingType, updateType } = config
  const SettingInput = settingInputs[settingType]
  const settingId = slugify(`${label}-${settingType}`)

  const update = data => updateAction({ updateType, page, sheet, data })
  const data = getData({ updateType, page, sheet })

  const inputProps = {
    guid: page.id,
    id: settingId,
    styleLevel: 'page',
    data,
    portal: true,
    update,
    ...config,
  }

  return <SettingInput {...inputProps} />
}

export const pageSettingsConfig = [
  PageSettingsPanel(PageStandardSettings),
  DesignSettingsPanel,
]

// TODO: We might benefit from standardizing the panel markup into it's
// own component now that we can see where the repeated markup occurs
export const PageSettings = ({ activePanels }) => {
  const activeSheet = useSelector(activeSheetSelector) || {}
  const activePage = useSelector(activeStyledPageSelector) || {}
  const pagePanels = useMemo(() => pageSettingsConfig, [activeSheet])

  return pagePanels.map(panel => {
    const { label, settings } = panel

    if (!activePanels.includes(label)) return null

    return (
      <div
        className="gcds--control-panel workspace-panel"
        key={`page-settings-panel-${label}`}
      >
        <div className="panel--info --workspace-panel--header">
          <div className="panel--title --workspace-panel--title">{label}</div>
        </div>
        <div className="panel--content workspace-panel--section field-settings-panel">
          {settings.map(setting => (
            <PageSetting
              key={`${setting.label}-${activePage.id}`}
              config={setting}
              page={activePage}
              sheet={activeSheet}
            />
          ))}
        </div>
      </div>
    )
  })
}
